var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import Menu from "../Menu/Menu";
import { IconArrowDown } from "@tabler/icons-react";
import Input from "../Input/Input";
import MenuItem from "../MenuItem/MenuItem";
import { useTheme } from "../ThemeProvider/ThemeProvider";
var Autocomplete = function (_a) {
    var id = _a.id, options = _a.options, placeholder = _a.placeholder, value = _a.value, className = _a.className, style = _a.style, label = _a.label, open = _a.open, multiSelect = _a.multiSelect, _b = _a.color, color = _b === void 0 ? "primary" : _b, _c = _a.width, width = _c === void 0 ? "15rem" : _c, 
    // Events
    onChange = _a.onChange, onClick = _a.onClick, onInputChange = _a.onInputChange;
    var _d = React.useState(null), inputAnchor = _d[0], setInputAnchor = _d[1];
    var _e = React.useState(open !== null && open !== void 0 ? open : false), isOpen = _e[0], setIsOpen = _e[1];
    var _f = React.useState(value
        ? multiSelect
            ? typeof value === "string"
                ? [value]
                : value
            : value
        : ""), inputValue = _f[0], setInputValue = _f[1];
    var _g = React.useState(options), filteredOptions = _g[0], setFilteredOptions = _g[1];
    var colorPalette = useTheme().theme.colorPalette;
    useEffect(function () {
        setInputValue(value !== null && value !== void 0 ? value : "");
    }, [value]);
    useEffect(function () {
        setFilteredOptions(function () {
            if (!inputValue)
                return options;
            if (!options)
                return;
            return options.filter(function (option) {
                return option.title
                    .toLowerCase()
                    .includes(inputValue.toString().toLowerCase()) ||
                    option.value
                        .toLowerCase()
                        .includes(inputValue.toString().toLowerCase());
            });
        });
    }, [options, inputValue]);
    var _handleMultiSelectOnClick = function (e, _a) {
        var title = _a.title, value = _a.value;
        setInputValue(!inputValue
            ? title
            : Array.isArray(inputValue)
                ? __spreadArray(__spreadArray([], inputValue, true), [title], false) : [inputValue, title]);
    };
    var _handleSingleSelectOnClick = function (e, _a) {
        var title = _a.title, value = _a.value;
        setIsOpen(false);
        setInputValue(title);
        onClick && onClick(e, { title: title, value: value });
        onInputChange && onInputChange(e, title);
        onChange && onChange(e, { title: title, value: value });
    };
    var _onMenuClick = function (e, _a) {
        var title = _a.title, value = _a.value;
        if (multiSelect)
            return _handleMultiSelectOnClick(e, { title: title, value: value });
        else
            return _handleSingleSelectOnClick(e, { title: title, value: value });
    };
    var _onInputClick = function (e) {
        setIsOpen(!isOpen);
    };
    var _onInputChange = function (e) {
        setIsOpen(true);
        setInputValue(e.target.value);
        onInputChange && onInputChange(e, e.target.value);
    };
    return (_jsxs("div", { children: [_jsx(Input, { color: color, width: width, placeholder: placeholder, value: inputValue, ref: setInputAnchor, label: label, trailingIcon: _jsx(IconArrowDown, {}), className: className, style: style, onClick: _onInputClick, onChange: _onInputChange }), _jsx(Menu, __assign({ open: isOpen, anchorElement: inputAnchor, minWidth: "".concat(inputAnchor === null || inputAnchor === void 0 ? void 0 : inputAnchor.offsetWidth, "px"), onClick: _onMenuClick, style: { backgroundColor: colorPalette.primary.grayScale[1] } }, { children: filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.map(function (option, index) { return (_jsx(MenuItem, { title: option.title, value: option.value }, index)); }) }))] }));
};
export default Autocomplete;
